import React from 'react'
import { InputGroup } from 'react-bootstrap'
import { NumberInput, type NumberInputProps } from '@ztechapps/webui.input'
import { ShowIf } from '@ztechapps/webui.util'
import { UomDisplay } from './QuantityWithUom'

export type QuantityInputWithUomProps = NumberInputProps & {
  symbol?: string
  className?: string
  // Arrives via QuantityWithUomInlineInput's shared `inputProps` bag; consumed by the display
  // component (QuantityWithUom), not this input. Destructured and dropped below -- not a DOM attribute.
  decimalPrecision?: number
}

/**
 * A number input with an optional UOM symbol suffix.
 * When symbol is provided, renders with InputGroup styling.
 * When no symbol, renders just the NumberInput.
 */
export const QuantityInputWithUom = ({
  symbol,
  className,
  decimalPrecision: _decimalPrecision,
  ...numberInputProps
}: QuantityInputWithUomProps) => {
  const numberInput = <NumberInput {...numberInputProps} />

  return (
    <>
      <ShowIf condition={!!symbol}>
        <InputGroup className={className}>
          {numberInput}
          <InputGroup.Text className="px-1">
            <UomDisplay>{symbol}</UomDisplay>
          </InputGroup.Text>
        </InputGroup>
      </ShowIf>
      <ShowIf condition={!symbol}>{numberInput}</ShowIf>
    </>
  )
}
